var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRowArrowDownWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.39645 4.39645C1.57001 4.22288 1.83944 4.2036 2.03431 4.33859L2.10355 4.39645L7.25 9.543L12.3964 4.39645C12.57 4.22288 12.8394 4.2036 13.0343 4.33859L13.1036 4.39645C13.2771 4.57001 13.2964 4.83944 13.1614 5.03431L13.1036 5.10355L7.60355 10.6036C7.42999 10.7771 7.16056 10.7964 6.96569 10.6614L6.89645 10.6036L1.39645 5.10355C1.20118 4.90829 1.20118 4.59171 1.39645 4.39645Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowArrowDownWhite);
export default __webpack_public_path__ + "static/media/row-arrow-down-white.c3f63e13.svg";
export { ForwardRef as ReactComponent };